<template>
  <div v-bind:class="['timeline-year', timelineYearClass]">
    {{ year }}
  </div>
</template>

<script>
export default {
  name: 'TimelineYear',
  props: {
    year: {
      type: String,
      required: true,
    },
    timelineYearClass: String,
  }
};
</script>

<style lang="scss">
@import '@/styles/functions.scss';

.timeline-year {
  color: rgba(255, 255, 255, 0.12);
  font-family: 'Roboto Condensed', sans-serif;
  font-weight: bold;
  font-size: 48px;
  line-height: 56px;
  position: relative;

  &:after {
    content: '';
    position: absolute;
    top: 48px;
    left: -48px;
    height: 148px;
    width: 100vw;
    background: linear-gradient(to bottom, rgba(255, 255, 255, 0.12) 0%, rgba(255, 255, 255, 0) 100%);
  }

  @include media-breakpoint-up(md) {
    font-size: 64px;
    line-height: 75px;

    &:after {
      top: 62px;
      left: -91px;
      height: 220px;
    }
  }

  @include media-breakpoint-up(lg) {
    &:after {
      content: none;
    }
  }
}
</style>
